import { useCallback, useState } from 'react';

export const INITIAL_LOADER_DETAILS = {
  phase: 'init',
  detail: '',
  backend: '',
  articleId: null,
  queueStatus: '',
  attempt: null,
  totalAttempts: null
};

/**
 * State of the full-screen generation loader (phase, backend, queue status, attempts).
 */
export function useGenerationLoader() {
  const [isFullScreenLoading, setIsFullScreenLoading] = useState(false);
  const [loaderType, setLoaderType] = useState('draft');
  const [loaderDetails, setLoaderDetails] = useState({ ...INITIAL_LOADER_DETAILS });

  const updateLoaderProgress = useCallback((patch) => {
    setLoaderDetails((prev) => ({ ...prev, ...patch }));
  }, []);

  return {
    isFullScreenLoading,
    setIsFullScreenLoading,
    loaderType,
    setLoaderType,
    loaderDetails,
    setLoaderDetails,
    updateLoaderProgress,
  };
}
